import React from 'react'

export const PrinterLoader = ({ size = 120, label = 'Carregando...' }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width={size}
        height={size}
      >
        <style>{`
          @keyframes printPaper {
            0% {
              transform: translateY(-8px);
              opacity: 0.2;
            }
            30% {
              opacity: 1;
            }
            100% {
              transform: translateY(8px);
              opacity: 0;
            }
          }
          @keyframes pulseLed {
            0%, 100% { fill: #22c55e; opacity: 1; }
            50% { fill: #eab308; opacity: 0.3; }
          }
          .animate-paper {
            animation: printPaper 1.2s infinite ease-in-out;
          }
          .animate-led {
            animation: pulseLed 0.8s infinite ease-in-out;
          }
        `}</style>

        {/* Corpo da Impressora */}
        <path d="M 28 18 H 72 A 6 6 0 0 1 78 24 V 52 C 78 68, 66 76, 50 76 C 34 76, 22 68, 22 52 V 24 A 6 6 0 0 1 28 18 Z" fill="#000000" />
        <path d="M 32 20 H 70 A 4 4 0 0 1 74 24 V 50 C 74 63, 64 71, 50 71 C 37 71, 30 63, 28 50 V 24 A 4 4 0 0 1 32 20 Z" fill="#FFFFFF" />
        <path d="M 35 20 H 65 A 3 3 0 0 1 68 23 V 40 C 68 47, 60 50, 50 50 C 40 50, 32 47, 32 40 V 23 A 3 3 0 0 1 35 20 Z" fill="#000000" />
        <rect x="42" y="27" width="16" height="2" rx="1" fill="#FFFFFF" />

        {/* LED Pulsante */}
        <circle cx="62" cy="44" r="2" className="animate-led" />

        {/* Papel Animado */}
        <g className="animate-paper">
          <rect x="37" y="48" width="26" height="34" fill="#FFFFFF" stroke="#000000" strokeWidth="2" rx="1" />
          <line x1="42" y1="55" x2="58" y2="55" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="42" y1="59" x2="53" y2="59" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
          <rect x="41" y="65" width="2" height="12" fill="#000000" />
          <rect x="44" y="65" width="1" height="12" fill="#000000" />
          <rect x="46" y="65" width="3" height="12" fill="#000000" />
          <rect x="50" y="65" width="1" height="12" fill="#000000" />
          <rect x="52" y="65" width="2" height="12" fill="#000000" />
          <rect x="55" y="65" width="3" height="12" fill="#000000" />
        </g>
      </svg>

      {label && (
        <span style={{ fontSize: '14px', fontFamily: 'sans-serif', color: '#666', fontWeight: '500' }}>
          {label}
        </span>
      )}
    </div>
  )
}

export default PrinterLoader